import * as v from "valibot";

import { rpcContract } from "../rpc";

/**
 * Public donation-progress snapshot for a live event.
 *
 * Anonymous-callable because the payload carries no PII — only the event's
 * fundraising target, the running raised total, and a distinct donor count.
 * Mirrors the SSE `donation-progress` payload (see `prd/live-event-donations.md`
 * §8) so the initial REST load and the live SSE pushes are render-compatible
 * shapes.
 */
export const getDonationProgressRpcContract = rpcContract({
  name: "get-donation-progress",
  paramsSchema: v.object({
    liveEventId: v.pipe(v.string(), v.uuid("liveEventId must be a UUID")),
  }),
  resultSchema: v.object({
    targetCents: v.number(),
    raisedCents: v.number(),
    donorCount: v.number(),
  }),
});

export type GetDonationProgressParams = v.InferOutput<(typeof getDonationProgressRpcContract)["paramsSchema"]>;
export type GetDonationProgressResult = v.InferOutput<(typeof getDonationProgressRpcContract)["resultSchema"]>;
